import ImagesRoute from "../assets/ImagesRoute";

export const ProductData = [
  {
    path: "/product/nn",
    img: ImagesRoute.IMG_6728,
    log: ImagesRoute.NNlog,
    gradient: "from-[#000000] to-[#545454]",
    title: "Nocturnal Wanderings",
    ubtitle: "夜を軽やかに、目に優しく。",
    stack: "Windowsソフトウェア",
    explain:
      "暗い部屋でも目に優しく、快適に作業を続けられます。Nocturnal Wanderingsを実行して、夜間の作業をもっと快適に。",
  },

  {
    path: "https://matitaka.dawn-waiting.com",
    img: ImagesRoute.manami_hydoro,
    log: ImagesRoute.matitaka_wh,
    gradient: "from-[#BC78FF] to-[#3DBBFF]",
    title: "街角のたからもの",
    subtitle: "私のお写真ポートフォリオ",
    stack: "Webサイト",
    explain: "私のお写真のポートフォリオです。",
  },
  {
    path: "/product/outfit",
    img: ImagesRoute.manamisky,
    log: ImagesRoute.outfitw,
    gradient: "from-[#C1EDE2] to-[#C1CDED]",
    title: "OUTFIT",
    subtitle: "失敗しない服選び。",
    stack: "Webアプリケーション",
    explain:
      "「この服、サイズ感合うかな？」そんな不安にさようなら。体型やサイズをリアルに再現したマネキンが、試着イメージをわかりやすく表示。オンラインショッピングをもっと便利に、もっと楽しく！",
  },
  {
    path: "/product/logis",
    img: ImagesRoute.IMG_152,
    log: ImagesRoute.logis_icon,
    gradient: "from-[#2a9d8f] to-[#dedede]",
    title: "Logis",
    subtitle: "情報、整理。伝達、スムーズ。",
    stack: "Webアプリケーション / 業務効率化",
    explain:
      "          大事な共有事項をメッセージアプリ等で配信していませんか?それだと見づらいし、見逃してしまう可能性も...そんな共有事項もここにまとめておきませんか？過去の最新のトピックからマニュアルまで一丸共有！",
  },
  {
    path: "/function/chronodawn",
    img: ImagesRoute.IMG_1417,
    log: ImagesRoute.chronodawn_log,
    gradient: "from-[#000000] to-[#545454]",
    title: "Chrornodawn",
    subtitle: "デジタル時計",
    stack: "Webアプリケーション",
    explain:
      "``シック``で``モダン``なオリジナルのデジタル時計。シンプルで優しい雰囲気があなたの作業をお供します。是非‘‘F11‘‘キー（フルスクリーンモード）でお楽しみください",
  },
  {
    path: "/product/write",
    img: ImagesRoute.IMG_7065,
    log: ImagesRoute.write_logo,
    gradient: "from-[#000000] to-[#545454]",
    title: "Write",
    subtitle: "メモソフト",
    stack: "windowsソフト ＆ クロスプラットフォームアプリ",
    explain: `DAWN-Writeはあなたの気分に寄り添う「着せ替えメモソフト」です。
                      無機質なテキストだけでは物足りない。
                  その時の気分に合ったテーマを選んで、
                  ふとした時に気持ちよくメモできる空間を作りましょう。
    `,
  },
  {
    path: "/material/dawn-wander",
    img: ImagesRoute.IMG_7033,
    log: ImagesRoute.table_5356682_1920,
    gradient: "from-[#000000] to-[#545454]",
    title: "Dawn-wander発表資料",
    subtitle: "UX変化分析アプリ",
    stack: "発表資料",
    explain: "研究室選抜プレゼン用に作成したweb資料",
  },
  {
    path: "/function/audioroutine",
    img: ImagesRoute.IMG_7018,
    log: ImagesRoute.Audioroutine_icon,
    gradient: "from-[#000000] to-[#545454]",
    title: "Dawn-AudioRoutine",
    subtitle: "-音-を使った処理",
    stack: "Webアプリケーション",
    explain: "",
  },
  {
    path: "/material/jumbubble_plan",
    img: ImagesRoute.pexels_thevibrantmachine_3066867,
    log: ImagesRoute.jumbubblelogo,
    gradient: "from-[#000000] to-[#BC78FF]",
    title: "JumBubble-Dayoff",
    subtitle: "みんなが主体的に音楽を",
    stack: "発表資料",
    explain: `JamBubble（ジャムバブル）は、
「車内」「部屋」「カフェ」など、同じ空間にいるみんなでリアルタイムに音楽を作り上げるためのアプリです。

ホスト（音楽を流す端末）が部屋を作り、QRコードやリンクを共有。
参加者はアカウント登録なしでアクセスして、自分の好きな曲をリクエストとして追加できます。

曲は順番にホストの端末で再生され、
まるで“その場の空気を全員で奏でている”ような体験を生み出します。`,
  },
  {
    path: "/product/outfit/new",
    img: ImagesRoute.manamisky,
    log: ImagesRoute.outfitw,
    gradient: "from-[#4198CD] to-[#C1CDED]",
    title: "OUTFIT",
    subtitle: "失敗しない服選び。",
    stack: "Webアプリケーション",
    explain:
      "「この服、サイズ感合うかな？」そんな不安にさようなら。体型やサイズをリアルに再現したマネキンが、試着イメージをわかりやすく表示。オンラインショッピングをもっと便利に、もっと楽しく！",
  },
  {
    path: "https://rumos.dawn-waiting.com/product/sangria/",
    img: ImagesRoute.sangria_phooto_3,
    log: ImagesRoute.sangira_icon,
    gradient: "from-[#000000] to-[#545454]",
    title: "Dawn-Sangria",
    subtitle: "ワインボトルが光のインテリアに",
    stack: "IoT",
    explain: `Dawn-Sangriaは、飲み終えたワインボトルを“灯り”へと生まれ変わらせるライトインテリアです。
ボトルに差し込むだけで、柔らかな光が広がり、空間を上品に演出します。
windowsソフトウェア「Dawn-rumos」から操作でき、光の色や明るさを自由に調整可能。
リビングを落ち着いた空間にしたり、ディナーの雰囲気を華やかにしたりと、シーンに合わせた演出が簡単に楽しめます。
名前の由来は「ワインカクテルのサングリア」と「夜明け（Dawn）」。
深みあるワインの色合いに、朝の光を差し込むイメージを込めています。
Dawn-Sangriaは、インテリアとしての美しさと実用性を両立させた、ちょっと特別なライトです。`,
  },
  {
    path: "https://rumos.dawn-waiting.com",
    img: ImagesRoute.IMG_7120,
    log: ImagesRoute.IMG_7112,
    gradient: "from-[#000000] to-[#BC78FF]",
    title: "Rumos",
    subtitle: "変わらぬ日々に魔法をかけて。",
    stack: "IoT/マルチプラットフォームアプリ/API",
    explain:
      "DawnRumosはもう使わなくなった雑貨から、いつもそばにある日用品、さらには家具に至るまであらゆるモノをライトインテリアとして再生し、それらをスマートかつ美しくコントロール。部屋に散らばる光のデバイスを一括で操り、空間全体の世界観そのものを切り替える“雰囲気演出プラットフォーム”です。",
  },
  {
    path: "https://hibi.dawn-waiting.com",
    img: ImagesRoute.IMG_2839,
    log: ImagesRoute.IMG_0168,
    gradient: "from-[#000000] to-[#BC78FF]",
    title: "日々写真館",
    subtitle: "お写真ポートフォリオ",
    stack: "Webサイト",
    explain: "お写真ポートフォリオ",
  },
  {
    path: "https://www.duskshift.dawn-waiting.com",
    img: ImagesRoute.manamisorami1,
    log: ImagesRoute.duskOwl_flaing,
    gradient: "from-[#000000] to-[#BC78FF]",
    title: "DuskShift",
    subtitle: "見守って、整えて、届けるシフト",
    stack: "Webサイト/Webアプリ",
    explain: `夜の時間を見守るフクロウのように、
無理なく、やさしく。
働く人のリズムに寄り添うシフト募集を`,
  },
  {
    path: "/material/rumos",
    img: ImagesRoute.sangria_phooto_1,
    log: ImagesRoute.sangria_phooto_4,
    gradient: "from-[#000000] to-[#BC78FF]",
    title: "Rumos発表資料",
    subtitle: "変わらぬ日々に魔法をかけて",
    stack: "発表資料",
    explain: `発表資料`,
  },
];
